// extracted by mini-css-extract-plugin
module.exports = {"comp":"R_comp__ZMy6b"};